export interface GroundToDocumentsKpi {
  documentsUploaded: number;
  conceptsGrounded: number;
  relationshipsExtracted: number;
  coveragePercent: number;
}

export type DocumentStatus = "Grounded" | "Processing";

export interface UploadedDocumentRow {
  id: string;
  name: string;
  type: string;
  status: DocumentStatus;
}

export interface RelationshipValidationSummary {
  totalExtracted: number;
  pendingValidation: number;
  validated: number;
  aiConfidencePercent: number;
}

export interface ProcessingFile {
  name: string;
  progressPercent: number;
}

// Dummy data matching Figma node 3672:37562 (Ground to Documents workspace).
export const GROUND_TO_DOCUMENTS_KPI: GroundToDocumentsKpi = {
  documentsUploaded: 14,
  conceptsGrounded: 128,
  relationshipsExtracted: 42,
  coveragePercent: 84
};

export const RELATIONSHIP_VALIDATION_SUMMARY: RelationshipValidationSummary = {
  totalExtracted: 42,
  pendingValidation: 12,
  validated: 30,
  aiConfidencePercent: 92
};

export const PROCESSING_FILE: ProcessingFile = {
  name: "ISO-14224-Plant-Operations-Standard.pdf",
  progressPercent: 78
};

// Total source documents for the initiative (only a subset is shown in the table below).
export const TOTAL_UPLOADED_DOCUMENTS_COUNT = 14;

export const DUMMY_UPLOADED_DOCUMENTS: UploadedDocumentRow[] = [
  {
    id: "1",
    name: "CFIHOS_Equipment_Class_Register_v1.5.xlsx",
    type: "XLSX",
    status: "Grounded"
  },
  {
    id: "2",
    name: "ISO-14224-Plant-Operations-Standard.pdf",
    type: "PDF",
    status: "Grounded"
  },
  {
    id: "3",
    name: "Offshore_Pipeline_Assembly_SOP.docx",
    type: "DOCX",
    status: "Grounded"
  },
  {
    id: "4",
    name: "OSDU_Core_Grounding_Model_Export.ttl",
    type: "TTL",
    status: "Processing"
  },
  {
    id: "5",
    name: "POSC_Caesar_Reference_Taxonomy.owl",
    type: "OWL",
    status: "Grounded"
  }
];
